export default __webpack_public_path__ + "static/media/checkDarkRed.412833c4.svg";